import { useEffect, useState } from "react";

import { calculateRiskRating, getMatrix, getContrastColor, MIL882EMatrix } from "../../helpers/riskHelper";
import { Badge } from "../ui/badge";

const RiskBadge = ({ riskMatrixName, probability, severity }) => {
  const [riskMatrix, setRiskMatrix] = useState(null);

  useEffect(() => {
    const loadRiskMatrix = async () => {
      try {
        const riskMatrix = await getMatrix(riskMatrixName);

        if (!riskMatrix) {
          setRiskMatrix(MIL882EMatrix);
          return;
        }

        setRiskMatrix(riskMatrix);
      } catch (error) {
        // Fallback to default matrix
        setRiskMatrix(MIL882EMatrix);
      }
    };

    loadRiskMatrix();
  }, [riskMatrixName]); // Add dependency to prevent infinite loop

  const rating = calculateRiskRating(probability, severity, riskMatrix);
  const backgroundColor = riskMatrix?.colors[rating] || "#000000";
  const textColor = getContrastColor(backgroundColor);

  return (
    <Badge
      className="font-bold py-1 px-2 rounded"
      style={{ backgroundColor, color: textColor }}
    >
      {rating}
    </Badge>
  );
};

export default RiskBadge;
